import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import XmlPartList from './xml-part-list';

const Title = styled.p`
`;

const SubTitle = styled.span`
  font-weight: bold;
  margin-right: 5px;
`;

const Wrapper = styled.div`
  margin-top: 10px;
`;

const StyledDiv = styled.div`
  width: 100%;
`;

const OrderInfo = ({
  intl,
  multiLineIds,
  index,
  renderField,
  form,
  serviceCenterId,
  parts,
  orderId,
  handlePartAction,
  handleRemoveSupersededPart,
  handleAddOfSupersededPart,
}) =>
  <Wrapper>
    <Title>
      <SubTitle>
        {intl.formatMessage(
          { id: 'fileUpload.ORDER_NUMBER' },
          { current: index, total: multiLineIds.length },
        )}
      </SubTitle>
    </Title>
    <StyledDiv>
      <Row>
        <Col span={12}>{renderField('equipmentSerialNumber')}</Col>
        <Col span={12}>{renderField('equipmentDescription')}</Col>
      </Row>
      <Row>
        <Col span={12}>{renderField('functionalLocationNumber')}</Col>
        <Col span={12}>{renderField('functionalLocationDescription')}</Col>
      </Row>
      <Row>
        <Col span={12}>{renderField('orderDescription')}</Col>
        <Col span={12}>{renderField('workcenterId')}</Col>
      </Row>
      <Row>
        <Col span={6}>{renderField('businessIndicator')}</Col>
        <Col span={6}>{renderField('salesPrice')}</Col>
        <Col span={6}>{renderField('startDate')}</Col>
        <Col span={6}>{renderField('travelTime')}</Col>
      </Row>
      <Row>
        <Col span={6}>{renderField('labourTime')}</Col>
        <Col span={6}>{renderField('miscellaniousCost')}</Col>
        <Col span={12}>{renderField('businessSubType')}</Col>
      </Row>
      {renderField('partList') &&
        <Row>
          <Col span={24}>
            <XmlPartList
              form={form}
              index={index}
              serviceCenterId={serviceCenterId}
              parts={parts}
              orderId={orderId}
              handlePartAction={handlePartAction}
              handleRemoveSupersededPart={handleRemoveSupersededPart}
              handleAddOfSupersededPart={handleAddOfSupersededPart}
            />
          </Col>
        </Row>
      }
    </StyledDiv>
  </Wrapper>;

OrderInfo.propTypes = {
  intl: PropTypes.object,
  multiLineIds: PropTypes.array,
  index: PropTypes.number,
  renderField: PropTypes.func,
  form: PropTypes.object,
  serviceCenterId: PropTypes.string,
  parts: PropTypes.array,
  orderId: PropTypes.string,
  handlePartAction: PropTypes.func,
  handleRemoveSupersededPart: PropTypes.func,
  handleAddOfSupersededPart: PropTypes.func,
};

export default injectIntl(OrderInfo);
